import { axios } from "~/plugins/request";
export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findBasicConfigData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/oldPlan/findBasicConfigData`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  saveOrUpdateField({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/configPlanField/saveOrUpdateField`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getDictionary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/fwxtdictionary/findAllItemByTypeCode",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetailEdit({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/shanghaiPlan/selectProgramInfoEdit`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findUniversityQueryList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/shanghaiPlan/findUniversityQueryList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      try {
        axios({
          method: "post",
          url: "/art/shanghaiPlan/selectSchemeList",
          data: params
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      } catch (e) {
        console.log(e);
      }
    });
  },
  findProfessionList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/shanghaiPlan/findProfessionList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/shanghaiPlan/save`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/shanghaiPlan/selectProgramInfo`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  deleteCondition({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`login/getUserDeleteLimits`).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  saveLeaveMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/initialPlan/saveLeaveMessage`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  remove({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/oldPlan/remove`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  schemeInspect({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/smartReport/inspect`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  saveAndSend({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/initialPlan/sendScheme`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  designThoughtSave({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/initialPlan/updateSchemeDesignThought`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findIdBySpecialityName({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/profession/findIdBySpecialityName`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getUserDeleteLimits({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/login/getUserDeleteLimits`).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getUniversityId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/university/findIdByUniversityName`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getPDF({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/estimatePlan/findExportById`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getPDF_shanDong({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/newPlan/findExportById`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findExportUrlById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/newPlan/findExportUrlById`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

};
